import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Controls } from '../model/model';

@Injectable({
  providedIn: 'root'
})

export class ValueService {
 private getDefaultControls(): Controls {
  return {
  producerId: 0,
  startDate: '',
  endDate: '',
  applicationIDs: []
}
  };

  private getStoredMessage(): Controls {
    const storedMessage = localStorage.getItem('input');
    return storedMessage ? JSON.parse(storedMessage) as Controls : this.getDefaultControls();
  }

  private readonly messageSource = new BehaviorSubject<Controls>(this.getStoredMessage());
  currentMessage = this.messageSource.asObservable();

  setData(message: Controls) {
    this.messageSource.next(message);
    this.storeMessage(message);
  }

  private storeMessage(message: Controls) {
    localStorage.setItem('input', JSON.stringify(message));
  }

  clearAllExceptInput(message: Controls) {
    const retainValue = localStorage.getItem('input');
    localStorage.clear();
    if (retainValue) {
      localStorage.setItem('input', JSON.stringify(message));
    }
  }
}